import React, { useEffect } from "react";

const CustomBarChart = ({monthNumber, selectedWeek, showSelectedType, days, data = [], width = 270, height = 160, gap = 15 }) => { 

  if (!Array.isArray(data) || data.length === 0) {
    return <div className="mb-[4.75rem] text-[#779CE5] font-hanken-grotesk font-[500]">No data available</div>;
  }

  const margin = { top: 40, right: 20, bottom: 40, left: 20 };
  const chartWidth = width - margin.left - margin.right;
  const chartHeight = height - margin.top - margin.bottom;

  const xSpacing = (chartWidth - gap * (data.length - 1)) / data.length;
  const barWidth = xSpacing / 2;
  const maxValue = Math.max(...data.map((d) => Math.max(d.SpendAmount, d.LoadAmount)));

  const totalBarsWidth = data.length * xSpacing + (data.length - 1) * gap;
  const startX = (chartWidth - totalBarsWidth) / 2 + margin.left;

  return (
    <svg width="100%" height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="xMidYMid meet">
      {data.map((d, index) => {
        const xPos = startX + index * (xSpacing + gap);

        const spendBarHeight = d.SpendAmount === 0 ? 2 : (d.SpendAmount / maxValue) * chartHeight;
        const loadBarHeight = d.LoadAmount === 0 ? 2 : (d.LoadAmount / maxValue) * chartHeight;

        return (
          <g key={d.Month}>
            <rect
              x={xPos}
              y={height - margin.bottom - loadBarHeight}
              width={barWidth}
              height={loadBarHeight}
              fill="#6b92ff"
            />

            <rect
              x={xPos + barWidth}
              y={height - margin.bottom - spendBarHeight}
              width={barWidth}
              height={spendBarHeight}
              fill="#559C7E"
            />

            <text
              x={xPos + barWidth / 2}
              y={height - margin.bottom - loadBarHeight - 15} 
              fill="white"
              textAnchor="middle"
              fontSize="11"
              fontWeight="bold"
            >
               {/* {`$${d.LoadAmount.toFixed(2)}`}  */}
               {`$${parseFloat(d.LoadAmount.toFixed(2)).toString()}`}
          
            </text>

            <text
              x={xPos + barWidth + barWidth / 2}
              y={height - margin.bottom - spendBarHeight - 15} 
              fill="white"
              textAnchor="middle"
              fontSize="11"
              fontWeight="bold"
            >
                {/* {`$${d.SpendAmount.toFixed(2)}`}  */}
                {`$${parseFloat(d.SpendAmount.toFixed(2)).toString()}`}
            </text>
          {
            !selectedWeek && (
                          <text
              x={xPos}
              y={height - 10}
              fill="white"
              textAnchor="start" 
              fontSize="14"
              fontWeight="bold"
              letterSpacing="2px"
              fontFamily="hanken grotesk"
            >
              { d.Month.substring(0, 3).toUpperCase()}
            </text>
            )
          }

          {
            selectedWeek && (
              <text
              x={xPos}
              y={height - 10}
              fill="white"
              textAnchor="start" 
              fontSize="14"
              fontWeight="bold"
              letterSpacing="2px"
              fontFamily="hanken grotesk"
            >
              { `${monthNumber[index]}/${days[index]}`}
            </text>
            )
          }


          {
           !selectedWeek && showSelectedType && (
              <text
              x={xPos + 40} 
              y={height - 10}
              fill="white"
              textAnchor="start" 
              fontSize="14"
              fontWeight="bold"
              letterSpacing="2px"
              fontFamily="hanken grotesk"
            >
              {days[index]}
            </text>
            )
          } 
          </g>
        );
      })}
    </svg>
  );
};

export default CustomBarChart;
